import { render, staticRenderFns } from "./PopupAntiLoss.vue?vue&type=template&id=c16973e4&scoped=true&"
import script from "./PopupAntiLoss.vue?vue&type=script&lang=js&"
export * from "./PopupAntiLoss.vue?vue&type=script&lang=js&"
import style0 from "./PopupAntiLoss.vue?vue&type=style&index=0&id=c16973e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c16973e4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/admin/workspace/ss/ss-web-game/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c16973e4')) {
      api.createRecord('c16973e4', component.options)
    } else {
      api.reload('c16973e4', component.options)
    }
    module.hot.accept("./PopupAntiLoss.vue?vue&type=template&id=c16973e4&scoped=true&", function () {
      api.rerender('c16973e4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/home/popup/PopupAntiLoss.vue"
export default component.exports